import VueRouter from "vue-router";
const { isNavigationFailure, NavigationFailureType } = VueRouter;

export function handleNavigationError(e: unknown) {
    if (isNavigationFailure(e, NavigationFailureType.redirected)) {
        console.debug(`Redirected to: ${e.from.path} from: ${e.to.path}`);
    }
    else if (isNavigationFailure(e, NavigationFailureType.duplicated)) {
        // Don't care
    }
    else {
        throw e;
    }
}
